module.exports = __webpack_public_path__ + "img/05.0100cfb6.jpg";